var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1002_15190)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 28.75,
    r: 27.75,
    fill: "#6158F5",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 28.75,
    r: 28.25,
    stroke: "url(#paint0_linear_1002_15190)",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1002_15190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 7C29.8092 7 30.4651 7.66038 30.4651 8.475V12.4083C30.4651 13.223 29.8092 13.8833 29 13.8833C28.1908 13.8833 27.5349 13.223 27.5349 12.4083V8.475C27.5349 7.66038 28.1908 7 29 7Z",
    fill: "url(#paint1_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7694 11.8016C13.3416 11.2256 14.2693 11.2256 14.8414 11.8016L17.6041 14.5829C18.1762 15.1589 18.1762 16.0929 17.6041 16.6689C17.0319 17.2449 16.1042 17.2449 15.5321 16.6689L12.7694 13.8876C12.1973 13.3116 12.1973 12.3777 12.7694 11.8016Z",
    fill: "url(#paint2_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2306 11.8016C45.8027 12.3777 45.8027 13.3116 45.2306 13.8876L42.4679 16.6689C41.8958 17.2449 40.9681 17.2449 40.3959 16.6689C39.8238 16.0929 39.8238 15.1589 40.3959 14.5829L43.1586 11.8016C43.7308 11.2256 44.6584 11.2256 45.2306 11.8016Z",
    fill: "url(#paint3_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7674 29.6167V28.1417C17.7674 21.8962 22.7964 16.8333 29 16.8333C35.2036 16.8333 40.2326 21.8962 40.2326 28.1417V29.6167H17.7674Z",
    fill: "url(#paint4_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 28.1417C8 27.327 8.65596 26.6667 9.46512 26.6667H13.3721C14.1813 26.6667 14.8372 27.327 14.8372 28.1417C14.8372 28.9563 14.1813 29.6167 13.3721 29.6167H9.46512C8.65596 29.6167 8 28.9563 8 28.1417Z",
    fill: "url(#paint5_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1628 28.1417C43.1628 27.327 43.8188 26.6667 44.6279 26.6667H48.5349C49.3441 26.6667 50 27.327 50 28.1417C50 28.9563 49.3441 29.6167 48.5349 29.6167H44.6279C43.8188 29.6167 43.1628 28.9563 43.1628 28.1417Z",
    fill: "url(#paint6_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.907 34.0417C11.907 33.227 12.5629 32.5667 13.3721 32.5667H44.6279C45.4371 32.5667 46.093 33.227 46.093 34.0417C46.093 34.8563 45.4371 35.5167 44.6279 35.5167H13.3721C12.5629 35.5167 11.907 34.8563 11.907 34.0417Z",
    fill: "url(#paint7_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7674 41.9083C17.7674 41.0937 18.4234 40.4333 19.2326 40.4333H38.7675C39.5766 40.4333 40.2326 41.0937 40.2326 41.9083C40.2326 42.7229 39.5766 43.3833 38.7675 43.3833H19.2326C18.4234 43.3833 17.7674 42.7229 17.7674 41.9083Z",
    fill: "url(#paint8_linear_1002_15190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6279 49.775C23.6279 48.9604 24.2839 48.3 25.093 48.3H32.907C33.7161 48.3 34.3721 48.9604 34.3721 49.775C34.3721 50.5896 33.7161 51.25 32.907 51.25H25.093C24.2839 51.25 23.6279 50.5896 23.6279 49.775Z",
    fill: "url(#paint9_linear_1002_15190)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1002_15190",
    x: -23.75,
    y: -24,
    width: 105.5,
    height: 105.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1002_15190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1002_15190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1002_15190",
    x: 2,
    y: 1,
    width: 58,
    height: 60.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282243 0 0 0 0 0.232969 0 0 0 0 0.8875 0 0 0 0.71 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_15190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_15190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1002_15190",
    x1: 1.25,
    y1: 1,
    x2: 56.7781,
    y2: 56.4718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1002_15190",
    x1: 29.3537,
    y1: 60.6771,
    x2: 90.2793,
    y2: 3.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.a799a1716c0d055816a54473bb471034.svg";
export { ForwardRef as ReactComponent };